import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from 'app/shared/util.service';
@Component({
    selector: 'mh-value-widget',
    templateUrl: './value-widget.component.html',
    styleUrls: ['./value-widget.component.scss'],
    standalone: false
})
export class ValueWidgetComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() value = '';
  @Input() description = '';
  @Input() icon = '';
  @Input() loading = false;
  @Input() error = false;
  @Input() route = '';
  @Input() enabled = false;
  @Input() product: string;
  @Input() gaKey: string;

  constructor(private router: Router, private utilService: UtilService) {}

  goToLink() {
    this.utilService.ga('corporative-dashboard', this.gaKey);
    this.router.navigate([this.route]);
  }
}
